export default __webpack_public_path__ + "static/popover-dark-mode-9c2c9d5b19cb074cf7a44a53c8971349.mp4";